const moveAllRight = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="m8.3 11.4 3.477-3.511L8.38 4.455 9.446 3.4l4.442 4.488-4.522 4.567zm-6 0 3.477-3.511L2.38 4.455 3.446 3.4l4.442 4.488-4.522 4.567z"/></svg>',
};

export { moveAllRight as default };
